import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { CreatePortfolioStepperDialog } from '~/components/ui/common/CreatePortfolioStepperDialog';

interface EmptyPortfolioStateProps {
  canCreate?: boolean;
}

export const EmptyPortfolioState: React.FC<EmptyPortfolioStateProps> = ({
  canCreate = false,
}) => {
  const [showCreatePortfolioDialog, setShowCreatePortfolioDialog] =
    useState(false);

  return (
    <>
      <div className="flex justify-content-center align-items-center min-h-screen p-4">
        <div
          style={{
            width: 'auto',
            maxWidth: '56rem',
            backgroundColor:
              'var(--bq-surface-card, var(--bq-color-gray-light2, #141414))',
            border:
              '1px solid var(--bq-border-muted, var(--bq-color-gray-border))',
            borderRadius: '4px',
            boxShadow:
              '0 20px 35px rgba(15, 23, 42, 0.12), 0 4px 10px rgba(15, 23, 42, 0.08)',
            color: 'var(--bq-text-primary, #1f2937)',
          }}
        >
          <div className="text-center p-6">
            <div className="mb-4">
              <i className="pi pi-briefcase text-6xl text-400"></i>
            </div>

            <h2 className="text-2xl font-bold text-900 mb-3">
              No Portfolio Found
            </h2>

            <p className="text-600 mb-5 line-height-3">
              You don't have any portfolios yet. Create your first portfolio to
              start analyzing and managing your investments.
            </p>

            {canCreate && (
              <div className="flex justify-content-center">
                <Button
                  label="Create New Portfolio"
                  icon="pi pi-plus"
                  onClick={() => setShowCreatePortfolioDialog(true)}
                  size="large"
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <CreatePortfolioStepperDialog
        visible={showCreatePortfolioDialog}
        onHide={() => setShowCreatePortfolioDialog(false)}
      />
    </>
  );
};
